var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("media-gallery-navigation"),
      _vm._v(" "),
      _c("media-gallery-filter", {
        attrs: { keyword: _vm.keyword, filters: _vm.filters },
        on: {
          keyword: _vm.handleKeywordChange,
          filter: _vm.handleFilterChange,
        },
      }),
      _vm._v(" "),
      _c("media-gallery-list"),
      _vm._v(" "),
      _c("media-gallery-action-bar", {
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  "global-button",
                  {
                    attrs: {
                      icon: "download",
                      disabled: !_vm.hasSelectedAssets || _vm.requestRunning,
                    },
                    on: { click: _vm.handleDownload },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("mediaGallery.actions.downloadSelected"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "global-button",
                  {
                    attrs: {
                      icon: "collection-add",
                      theme: "secondary",
                      disabled: !_vm.hasSelectedAssets || _vm.requestRunning,
                    },
                    on: { click: _vm.handleCollection },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("mediaGallery.actions.addToCollection"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("global-input-checkbox", {
                      attrs: {
                        label: _vm.$t("mediaGallery.actions.selectAll"),
                        value: _vm.selectedAll,
                        disabled: _vm.isEmpty || _vm.requestRunning,
                      },
                      on: { input: _vm.handleSelectAll },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }